import { LoaderProgressBarComponent } from './progress-bar/progress-bar.component';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoaderService } from './loader.service';
import { LOADER_TYPE } from './loader.model';
import { InfiniteLoaderComponent } from './infinite-loader/infinite-loader.component';

@Component({
  selector: 'loader',
  standalone: true,
  imports: [CommonModule, InfiniteLoaderComponent, LoaderProgressBarComponent],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  LOADER_TYPE = LOADER_TYPE;
  loader$ = this.loaderService.getLoader();

  constructor(private loaderService: LoaderService) {}
}
